import { getDropDownProps } from "./dropDown/getDropDownProps";

export const getDefaultProps = ({
    device,
    searchMode,
    placeholders,
    searchParams
}) => {
    const dropDown = getDropDownProps({
        device,
        searchType: searchMode,
        placeholders
    });

    const { isSearchPage, searchTerm } = searchParams;

    return {
        dropDown,
        inputValue: isSearchPage ? searchTerm : ""
    };
};
